import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { useEnum } from "@/api/services/global/enum";
import { useTagOptions } from "@/api/services/main/tag";
import { JobInfoItem } from "@/features/job/components/job-detail/JobInfoItem";
import { findLabelByValue } from "@/utils/object";
import { DATE_FORMAT } from "@/constants/datetime";
import dayjs from "dayjs";

type TJobStatusDetailProps = {
  defaultValues?: Partial<TJobForm>;
  isDraft?: boolean;
};

export const JobStatusDetail: FC<TJobStatusDetailProps> = ({ defaultValues, isDraft }) => {
  const { data: jobStatusOptions } = useEnum("EJobStatus");
  const { data: jobTagOptions } = useTagOptions("job");

  // Resolve tag labels from master by id
  const tagLabel = (defaultValues?.tagIds ?? [])
    .map((id) => jobTagOptions.find((opt) => opt.value === id)?.label)
    .filter((item): item is string => Boolean(item))
    .join("、");

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="ステータス状況" />} padding="24px" showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <JobInfoItem label="ステータス" value={findLabelByValue(jobStatusOptions, defaultValues?.status)} required />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="タグ（優先ステータス）" value={tagLabel} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem
              label="募集開始日"
              value={
                defaultValues?.startDate && dayjs(defaultValues.startDate).isValid()
                  ? dayjs(defaultValues.startDate).format(DATE_FORMAT)
                  : ""
              }
            />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem
              label="募集終了日"
              value={
                defaultValues?.endDate && dayjs(defaultValues.endDate).isValid()
                  ? dayjs(defaultValues.endDate).format(DATE_FORMAT)
                  : ""
              }
            />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="紹介事業所名" value={defaultValues?.matchOffice?.officeName} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="求人担当者" value={defaultValues?.recruiter?.fullName} required />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="ステータスメモ" value={defaultValues?.statusMemo} type="textArea" isShowDivider={false} />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
